import { render, staticRenderFns } from "./Proxima.vue?vue&type=template&id=0265fb94&scoped=true&"
import script from "./Proxima.vue?vue&type=script&lang=js&"
export * from "./Proxima.vue?vue&type=script&lang=js&"
import style0 from "./Proxima.vue?vue&type=style&index=0&id=0265fb94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0265fb94",
  null
  
)

export default component.exports